import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar } from '@inmoment/the-kitchen';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example', 'ErrorObject', 'ErrorStates'].map(convertArrayToTabBar);
export const data2 = ['Key', 'Examples'].map(convertArrayToTabBar);

export const InputFieldDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('Example');
  const [maskTab, setMaskTab] = React.useState('Key');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <>
      <div>
        <p className="kxi-text-400 kxi-text-normal">InputField Usage Notes</p>
        <br />
        <p className="kxi-text-small kxi-text-300">
          This component <b>requires a 2px overflowable area</b> around the component. This allows the border to have the full room to expand when
          active. If the proper overflowable area is not available, the border when active will appear to be cut off.
        </p>
        <br />
        <br />
      </div>
      <div>
        <p className="kxi-text-400 kxi-text-normal">InputField Status</p>
        <br />
        <div style={{ height: 46 }}>
          <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
        </div>
        {tab === 'Example' && (
          <CodeBlock
            hasTopRadius={false}
            code={`{
  state: 'error';
  text: 'Oh no!';
}`}
          />
        )}
        {tab === 'ErrorObject' && (
          <CodeBlock
            hasTopRadius={false}
            code={`export interface ErrorObject {
  state: ErrorStates;
  text?: string;
}`}
          />
        )}
        {tab === 'ErrorStates' && <CodeBlock hasTopRadius={false} code="export type ErrorStates = 'success' | 'warning' | 'error';" />}
        <br />
        <p className="kxi-text-400">InputField Masks</p>
        <br />
        <div style={{ height: 46 }}>
          <TabBar stretch data={data2} color={theme} onTabChange={({ tab }) => setMaskTab(tab!.title)} />
        </div>
        {maskTab === 'Key' && (
          <CodeBlock
            code={`9 - any numeric character
a - any alpha character
* - any alphanumeric character`}
          />
        )}
        {maskTab === 'Examples' && (
          <CodeBlock
            code={`(999) 999-9999 - Phone Number

99/99/9999 - Date

99-999999 - Basic

999-99-9999 - SSN

a*-999-a999 - Serial Number`}
          />
        )}
      </div>
    </>
  );
};
